import BaseLayout from './BaseLayout';

export { BaseLayout };
